import { createSlice } from '@reduxjs/toolkit';
import { setDefinitions } from '../actions/SetDefinitions';
const initialState = {};
export const nexaTransmittersSlice = createSlice({
    name: 'nexa_transmitters',
    initialState,
    reducers: {
        nexaTransmittersCleared: () => {
            return {};
        },
        nexaTransmitterUpdated: (state, action) => {
            state[action.payload.id] = action.payload;
        },
        nexaTransmitterDeleted: (state, action) => {
            delete state[action.payload];
        },
        nexaTransmittersReplaced: (state, action) => {
            const newState = {};
            for (const o of action.payload) {
                newState[o.id] = o;
            }
            return newState;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(setDefinitions, (_, action) => {
            const newState = {};
            for (const o of action.payload.nexa_transmitters) {
                newState[o.id] = o;
            }
            return newState;
        });
    }
});
export const selectNexaTransmitters = (state) => state.definitions.nexa_transmitters;
export const selectNexaTransmitter = (id) => (state) => id == undefined ? undefined : state.definitions.nexa_transmitters[id];
export const { nexaTransmittersCleared, nexaTransmitterUpdated, nexaTransmitterDeleted, nexaTransmittersReplaced } = nexaTransmittersSlice.actions;
export const nexaTransmitterAdded = nexaTransmitterUpdated;
export default nexaTransmittersSlice.reducer;
